export default __webpack_public_path__ + "static/media/atom-i-settings.efc13cfb.svg";